module.exports = __webpack_public_path__ + "img/06-oval-not-convex-7-base.1af90e69.svg";